module.exports = __webpack_public_path__ + "img/gold-medal.ec1e977e.png";